<template>
	<div class="drawer">
		<el-drawer
		size="363px"
		title="我是标题"
		:visible.sync="drawerStatus"
		:with-header="false"
		@close='close'
		>
			<el-form style="padding:100px 36px 0 0px;">
				<el-form-item label="流程名称：" :label-width="formLabelWidth" >
					{{curItem.flow_name}}
				</el-form-item>
				<el-form-item label="流程分类：" :label-width="formLabelWidth" >
					<span v-if="curItem.flow_category===1">押金</span>
					<span v-if="curItem.flow_category===3">充值</span>
					<span v-if="curItem.flow_category===2">通用</span>
				</el-form-item>
				<el-form-item label="退款期限：" :label-width="formLabelWidth" >
					<el-input v-model="duration" placeholder="请输入" size="mini" @input="inputDuration">
						<template slot="append">天</template>
					</el-input>
				</el-form-item>
				<el-form-item label="审核人：" :label-width="formLabelWidth" >
					<div v-for="(item,index) in userList1" :key="index">
						{{$public.formatNumTochinese(index+1)}}级
						<el-select style="width:150px;" filterable v-model="userList1[index]" size="mini">
							<el-option v-for="staff in staffList" :key="staff.id" :label="staff.name" :value="staff.id+','+staff.name" :disabled="userList1.indexOf(staff.id+','+staff.name)>-1">
							</el-option>
						</el-select>
						<img v-if="index===0" @click="jia" src="../../../../assets/img/jiaItem.png" style="vertical-align: middle;margin-left:5px;cursor: pointer;width:20px;"/>
						<img v-if="index>0" @click="jian(index)" src="../../../../assets/img/jianItem.png" style="vertical-align: middle;margin-left:5px;cursor: pointer;height: 20px;"/>
					</div>
				</el-form-item>
				<el-form-item label="抄送人：" :label-width="formLabelWidth" >
					<el-select style="width:210px;" filterable v-model="userList2" multiple size="mini">
						<el-option v-for="staff in staffList" :key="staff.id" :label="staff.name" :value="staff.id+','+staff.name">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth: '118px',
				staffList:[],
				
				duration:0,
				userList1:[''],
				userList2:[],
			}
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted() {
			this.$nextTick(()=>{
				this.drawerStatus=true;
				this.duration = this.curItem.duration;
				for(let i=0;i<this.curItem.approve_users.length;i++){
					this.userList1[i] = (this.curItem.approve_users[i].receive_id+','+this.curItem.approve_users[i].receive_name)
				}
				for(let i=0;i<this.curItem.copy_users.length;i++){
					this.userList2[i] = (this.curItem.copy_users[i].receive_id+','+this.curItem.copy_users[i].receive_name)
				}
			})
			this.$http.get(process.env.VUE_APP_Url_baseData+'/api/depart/treeAppeoveCopy').then(res => {
				if (res.code == 0) {
					this.staffList = res.data;
				}
			})
		},
		methods: {
			close(){
				this.$emit("submit",{type:'close'})
			},
			inputDuration(){
				this.duration = this.$public.FInt(this.duration)
			},
			jia(){
				this.userList1.push('');
			},
			jian(index){
				this.userList1.splice(index,1);
			},
			submit(){
				if(this.$public.isNull(this.duration)){
					this.$message({
						message: '退款期限输入有误！！',
						type: 'error'
					});
					return ;
				}
				let approve_users = [];
				for(let i=0;i<this.userList1.length;i++){
					if(this.$public.isNull(this.userList1[i])){
						this.$message({
							message: '请输入'+this.$public.formatNumTochinese(i+1)+'级审核人！！',
							type: 'error'
						});
						return ;
					}
					approve_users.push({
						"receive_id": this.userList1[i].split(',')[0],
						"receive_name": this.userList1[i].split(',')[1],
					})
				}
				let copy_users = [];
				for(let i=0;i<this.userList2.length;i++){
					copy_users.push({
						"receive_id": this.userList2[i].split(',')[0],
						"receive_name": this.userList2[i].split(',')[1],
					})
				}
				let params = {
					"_id": this.curItem._id,
					"flow_name": this.curItem.flow_name,  // 流程名称
					"flow_category": this.curItem.flow_category,   // 流程分类
					"duration":Number(this.duration),
					"status": 1,
					"approve_users": approve_users,
					"copy_users": copy_users,
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_Url_member+'/api/middleware/RefundAudit/Flow/Update', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$emit("submit",{type:'success'})
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
